module.exports = __webpack_public_path__ + "plane-blueprint-chocolate-ice-cream.972635127ed1e16b8a0d.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/plane-blueprint-chocolate-ice-cream.svg
// module id = ../../../../../src/assets/img/plane-blueprint-chocolate-ice-cream.svg
// module chunks = main